// removed by extract-text-webpack-plugin
module.exports = {"header":"index__header___2FuYt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Header/index.css
// module id = 1006
// module chunks = 37